import { createRouter, createWebHistory } from 'vue-router'
import localeRoutes from './localeRoutes'

const currentPath = window.location.pathname

let initialRoutes
let locale
if(!currentPath || currentPath == '/') {
    const persistedLocale = localStorage.getItem("user-locale")
    if(persistedLocale) {
        locale = persistedLocale
    } else {
        locale = 'et'
    }
}
if(currentPath.includes('/en')) {
    locale = 'en'
}
if(currentPath.includes('/et')) {
    locale = 'et'
}

if(!locale) {
    locale = 'et'
}

initialRoutes = localeRoutes.decideInitialRoutes(locale)

const router = createRouter({
    history: createWebHistory(process.env.VUE_APP_BASE_URL),
    routes: initialRoutes,
    scrollBehavior() {
        return { top: 0 };
    },
})

router.beforeEach((to, from, next) => {
    const newLocale = to.params.locale;
    const oldLocale = from.params.locale;

    if(to.matched.length == 0) {
        router.push('/')
    }

    if(newLocale && oldLocale) {
        if (newLocale !== oldLocale) {
            switch (newLocale) {
                case 'et': {
                    const newRoutes = localeRoutes.decideInitialRoutes('et')
                    router.removeRoute('mainEN')
                    router.addRoute(newRoutes[0])

                    break
                }
        
                case 'en': {
                    const newRoutes = localeRoutes.decideInitialRoutes('en')
                    router.removeRoute('mainET')
                    router.addRoute(newRoutes[0])
                    
                    break
                }
        
                case 2:
                    break
        
                case 3:
                    break
            }
            next();
        } else {
            next();
        }
    } else {
        next()
    }
});

export default router